import React, { HTMLAttributes } from 'react';
import { ImmutableDiaryNodeEntity } from '..';

import NodeDiaryFull from './Full';
import NodeDiaryTeaser from './Teaser';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  viewMode: string;
  entity: ImmutableDiaryNodeEntity;
}

const NodeDiary: React.FC<Props> = ({ viewMode, entity, className }) => {
  switch (viewMode) {
    case 'teaser':
      return <NodeDiaryTeaser entity={entity} className={className} />;
    default:
      return <NodeDiaryFull entity={entity} className={className} />;
  }
};

export default NodeDiary;
